<template>
  <div>
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="4" class="pl-3">
        <div class="vx-row mb-base w-full">
          <div class="vx-col w-full md:w-1/2 " >
            <div v-if="noComparison" class="mt-5">
              {{ $t('MRMR.Statement.NoPreviousComparaison') }}
            </div>
            <div v-else>
              <form-label>{{$t('MRMR.Statement.Title')}}</form-label>
              <v-select
                label="periodName"
                :options="statementList"
                v-model="comparisonStatement"
                class="w-full"
              />
              <a class="text-primary" href="#" @click.prevent="viewDetailedReport()">{{ $t('MRMR.Statement.ViewDetailedReport')}}</a>
            </div>
          </div>
         
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="4" class="pl-3">
        <div class="vx-row mb-base w-full">
          <!-- <div class="vx-col w-full md:w-1/2 " >
            <form-label>{{$t('MRMR.Statement.SelectElementsChart')}}</form-label>
            <v-select
              label="name"
              multiple
              :options="availableElements"
              v-model="selectedElements"
              :reduce="e => e.id"
              class="w-full"
            />
          </div> -->
          <div class="vx-col w-full md:w-1/2 " >
            <form-label>{{$t('MRMR.DiagramType.DetailedOrSummaryLabel')}}</form-label>
            <vs-switch class="mt-2" color="primary" icon-pack="feather"  v-model="detailedDiagram">
              <template #off>
                {{$t('MRMR.DiagramType.Summary')}}
              </template>
              <template #on>
                {{$t('MRMR.DiagramType.Detailed')}}
              </template>
            </vs-switch>
          </div>
          <div class="vx-col w-full md:w-1/2 " >
            <form-label>{{$t('MRMR.OwnershipCalculation.Label')}}</form-label>
            <vs-switch class="mt-2" color="primary" icon-pack="feather"  v-model="considerOwnershipPercentage">
              <template #off>
                {{ $t('No') }}
              </template>
              <template #on>
                {{ $t('Yes') }}
              </template>
            </vs-switch>
            <span v-if="considerOwnershipPercentage && comparisonStatement">{{ comparisonStatement.periodName }} - v{{ comparisonStatement.version }}: {{ comparisonStatement.ownership }} %</span><br />
            <span v-if="considerOwnershipPercentage">{{ selectedStatement.period.name }} - v{{ selectedStatement.version }}: {{ selectedStatement.ownership }} %</span>
          </div>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="4" class="pr-3" >
        <ul class="centerx">
          <li>
            <vs-checkbox v-model="undergroundSelected">{{ undergroundLabel }}</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="openPitSelected">{{ openPitLabel }}</vs-checkbox>
          </li>
        </ul>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" >
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="6" class="p-3" >
        <vx-card :title="$t('MRMR.Entry.Tonnage')" title-color="black">
          <vue-apex-charts ref="chartTonnage"  :options="tonnageChartOptions" :series="tonnageSeries"></vue-apex-charts>
        </vx-card>
      </vs-col>
      <!-- <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="4" class="p-3" v-for="selectedElement in sortedSelectedElements" :key="'chartRow' + selectedElement" >
        <vx-card :title="getSelectedElementLabel(selectedElement)" title-color="black">
          <element-chart ref="selectedElementChart" 
            :selectedStatement="getSelectedStatement()" 
            :comparisonStatement="comparisonStatement" 
            :detailedDiagram="detailedDiagram"
            :openPitSelected="openPitSelected"
            :undergroundSelected="undergroundSelected"
            :element="selectedElement"
            :yAxisLabel="getSelectedElementLabel(selectedElement)">
          </element-chart>
        </vx-card>     
      </vs-col> -->
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="6" class="p-3" >
        <vx-card :title="getSelectedElementLabel(selectedElement)" title-color="black">
          <element-chart ref="selectedElementChart"
            :considerOwnershipPercentage="considerOwnershipPercentage"
            :selectedStatement="selectedStatement" 
            :comparisonStatement="comparisonStatement" 
            :detailedDiagram="detailedDiagram"
            :openPitSelected="openPitSelected"
            :undergroundSelected="undergroundSelected"
            :element="selectedElement"
            :yAxisLabel="getSelectedElementLabel(selectedElement)">
          </element-chart>
        </vx-card>     
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="space-between" >
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-lg="12" class="m-3">
        <statement-comparison-grid 
          :tableData="tableData"
          :summaryTableData="summaryTableData"
          :selectedStatementName="selectedStatementName"
          :comparisonStatementName="comparisonStatementName" />
      </vs-col>
    </vs-row>
  </div>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select';
import { FormLabel } from "../../../../shared/components";
import ResourceTypeEnum from "../../ResourceTypeEnum.js"
import MiningTypeEnum from "../../MiningTypeEnum.js"
import StatementComparisonGrid from "../components/StatementComparisonGrid.vue"
import ResourceCategoryEnum from '../../ResourceCategoryEnum.js';
import ElementChart from '../components/ElementChart.vue'
import ElementEnum from '@/app/shared/ElementEnum.js';

export default {
  components: {
    VueApexCharts,
    vSelect,
    FormLabel,
    StatementComparisonGrid,
    ElementChart
  },
  props: {
    selectedStatement: {
      type: Object,
      default: () => {}
    },
    readOnly : {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statementList() {
      if (this.$props.selectedStatement) {
        let emptyStatements = this.$store.state.mrmr.statements.filter(s => s.id !==  this.$props.selectedStatement.id);
        emptyStatements = emptyStatements.filter(s => s.projectId ===  this.$props.selectedStatement.projectId);
        emptyStatements = emptyStatements.filter(s => s.periodDate < this.$props.selectedStatement.periodDate);
        return emptyStatements.sort((a, b) => { return (a.periodDate < b.periodDate) ? 1 : -1 });
      }
      else
        return this.$store.state.mrmr.statements;

    },
    noComparison() {
      return this.statementList === undefined || this.statementList === null || this.statementList.length === 0;
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    selectedStatementName() {
      if (this.$props.selectedStatement)
        return this.$props.selectedStatement.period.name;
      else
        return "";
    },
    comparisonStatementName() {
      if (this.comparisonStatement)
        return this.comparisonStatement.periodName;
      else
        return "";
    },
    undergroundLabel() {
      return this.$t("MRMR.MiningType." + MiningTypeEnum.Underground);
    },
    openPitLabel() {
      return this.$t("MRMR.MiningType." + MiningTypeEnum.OpenPit);
    },
    sortedSelectedElements() {
      return this.selectedElements.map(x => x).sort();
    },
    availableElements() {
      return this.getAvailableElements();
    },
    selectedElement() {
      return ElementEnum.Gold;
    }
  },
  watch: {
    openPitSelected() {
      this.refreshDiagram();
    },
    undergroundSelected() {
      this.refreshDiagram();
    },
    comparisonStatement() {
      this.refreshDiagram();
    },
    detailedDiagram() {
      this.refreshDiagram();
    },
    selectedElements() {
      this.refreshDiagram();
    },
    sortedSelectedElements() {
      this.refreshDiagram();
    },
    considerOwnershipPercentage() {
      this.refreshDiagram();
    }
  },
  data() {
    return {
      selectedElements: [],
      comparisonStatement: null,
      undergroundSelected: true,
      openPitSelected: true,
      tonnageChartOptions: {
        colors: ['#666666', '#0099cc', '#000000', '#00cc00', '#ff0000', '#FFD700'],
        chart: {
        },
        xaxis: {
          categories: []
        },
        yaxis: [],
        stroke: {
          width: [4, 4, 2, 2, 2],
          curve: ['straight', 'straight', 'straight', 'straight', 'straight'],
          dashArray: [0, 0, 5, 5, 5]
        },
        markers: {
          size: [0, 0, 0, 0, 0, 6]
        }
      },
      auOzChartOptions: {
        colors: ['#666666', '#0099cc', '#000000', '#00cc00', '#ff0000', '#FFD700'],
        chart: {
        },
        xaxis: {
          categories: []
        },
        yaxis: [],
        stroke: {
          width: [4, 4, 2, 2, 2],
          curve: ['straight', 'straight',  'straight', 'straight', 'straight'],
          dashArray: [0, 0, 5, 5, 5]
        },
        markers: {
          size: [0, 0, 0, 0, 0, 6]
        }
      },
      tableData: [],
      summaryTableData: [],
      tonnageSeries: [],
      auOzSeries: [],
      detailedDiagram: false,      
      elements: [
        { id:ElementEnum.Gold, name: this.$t("Element." + ElementEnum.Gold) },
        { id:ElementEnum.Silver, name: this.$t("Element." + ElementEnum.Silver) },
        { id:ElementEnum.Copper, name: this.$t("Element." + ElementEnum.Copper) },
        { id:ElementEnum.Zinc, name: this.$t("Element." + ElementEnum.Zinc) },
        { id:ElementEnum.Lead, name: this.$t("Element." + ElementEnum.Lead) }
      ],
      considerOwnershipPercentage: false
    };
  },
  mounted() {
    const yearEndList = this.statementList.filter(s => s.isPeriodYearEnd)
    if (yearEndList !== undefined)
      this.comparisonStatement = yearEndList[0];
    this.selectedElements = this.getAvailableElements().map(x => x.id);
  },
  
  methods: {
    viewDetailedReport() {
      this.$router.push({ name: "mrmr-statements-comparison", query: { statementAId: this.comparisonStatement.id, statementBId: this.selectedStatement.id, readOnly: this.$props.readOnly } });
    },
    refreshDiagram() {
      if (this.detailedDiagram) this.defineDiagramSettings();
      else this.defineSummaryDiagramSettings();
    },
    defineDiagramSettings() {
      const resourceTypes = [ResourceTypeEnum.Proven, ResourceTypeEnum.Probable, ResourceTypeEnum.Measured, ResourceTypeEnum.Indicated, ResourceTypeEnum.Inferred, ResourceTypeEnum.PotentialMineral];
      this.calculateDiagramSettings(resourceTypes, this.getStatementStats, "MRMR.ResourceType");
    },
    defineSummaryDiagramSettings() {
      const resourceCategories = [ResourceCategoryEnum.Reserve, ResourceCategoryEnum.Resource, ResourceCategoryEnum.Inferred, ResourceCategoryEnum.PotentialMineral];
      this.calculateDiagramSettings(resourceCategories, this.getSummaryStatementStats, "MRMR.ResourceCategories");
    },
    calculateDiagramSettings(types, statsFunc, localizationPrefix) {
      const miningTypes = [];
      if (this.undergroundSelected) {
        miningTypes.push(MiningTypeEnum.Underground)
      }

      if (this.openPitSelected) {
        miningTypes.push(MiningTypeEnum.OpenPit)
      }
      const categories = [];
      const selectedTonnage = [];
      const comparedTonnage = [];
      const tonnageVariance = [];
      const zeroValues = [];
      const plus10Values = [];
      const minus10Values = [];
      const selectedAuOZ = [];
      const comparedAuOz = [];
      const auOZVariance = [];
      const tableData = [];

      types.forEach(type => {
        categories.push(this.$t(localizationPrefix + "." + type));

        let selectedTonnageValue = 0;
        let selectedAuOZValue = 0;
        let selectedAuGradeValue = 0;
        let comparisonTonnageValue = 0;
        let comparisonAuOZValue = 0;
        let comparisonAuGradeValue = 0;

        const selectedStatementValues  = statsFunc(this.selectedStatement, type, miningTypes);
        selectedTonnageValue = selectedStatementValues.tonnageValue;
        selectedAuOZValue = selectedStatementValues.auOZValue;
        selectedAuGradeValue = selectedStatementValues.auGradeValue;

        selectedTonnage.push(selectedTonnageValue);
        selectedAuOZ.push(selectedAuOZValue);

        
        if (this.comparisonStatement !== undefined && this.comparisonStatement !== null) {
          const comparisonStatementValues  = statsFunc(this.comparisonStatement, type, miningTypes);
          comparisonTonnageValue = comparisonStatementValues.tonnageValue;
          comparisonAuOZValue = comparisonStatementValues.auOZValue;
          comparisonAuGradeValue = comparisonStatementValues.auGradeValue;

          const varianceTonnage = comparisonTonnageValue === 0 ? selectedTonnageValue === 0 ? 0 : 100 : (selectedTonnageValue - comparisonTonnageValue) * 100 / comparisonTonnageValue;
          const varianceAuOZ = comparisonAuOZValue === 0 ? selectedAuOZValue === 0 ? 0 : 100 : (selectedAuOZValue - comparisonAuOZValue) * 100 / comparisonAuOZValue;
          const varianceAuGrade = comparisonAuGradeValue === 0 ? selectedAuGradeValue === 0 ? 0 : 100 : (selectedAuGradeValue - comparisonAuGradeValue) * 100 / comparisonAuGradeValue;

          comparedTonnage.push(comparisonTonnageValue);
          comparedAuOz.push(comparisonAuOZValue);
          tonnageVariance.push(varianceTonnage);
          auOZVariance.push(varianceAuOZ);
          zeroValues.push(0);
          plus10Values.push(10);
          minus10Values.push(-10);

          tableData.push({
            resource: type,
            selectedTonnage: selectedTonnageValue,
            comparisonTonnage : comparisonTonnageValue,
            diffTonnage :selectedTonnageValue - comparisonTonnageValue,
            varianceTonnage,
            selectedAuOZ : selectedAuOZValue,
            comparisonAuOZ : comparisonAuOZValue,
            varianceAuOZ,
            diffAuOZ :selectedAuOZValue - comparisonAuOZValue,
            selectedAuGrade : selectedAuGradeValue,
            comparisonAuGrade : comparisonAuGradeValue,
            diffAuGrade :selectedAuGradeValue - comparisonAuGradeValue,
            varianceAuGrade
          });
        } else {
          tableData.push({
            resource: type,
            selectedTonnage: selectedTonnageValue,
            selectedAuOZ : selectedAuOZValue,
            selectedAuGrade : selectedAuGradeValue
          });
        }
      });

      const selectedStatementTonnageSerie = {
        type: 'bar',
        name:  this.selectedStatement.period.name,
        data: selectedTonnage
      }

      const comparedStatementTonnageSerie = {
        type: 'bar',
        name: this.comparisonStatementName,
        data: comparedTonnage
      }

      const tonnageVarianceSerie = {
        type: 'scatter',
        name: "Variance",
        data: tonnageVariance
      }

      const maxTonnageVariance =  Math.max.apply(null, tonnageVariance)

      const zeroSerie = {
        type: 'line',
        name: "0",
        data:  zeroValues
      }

      const plus10Serie = {
        type: 'line',
        name: "+10 %",
        data:  plus10Values
      }

      const minus10Serie = {
        type: 'line',
        name: "-10 %",
        data:  minus10Values
      }

      const tonnageYaxis = [
        {
          seriesName: this.selectedStatement.period.name,
          tickAmount : 5,
          forceNiceScale : true,
          title: {
            text: this.$t('MRMR.Entry.Tonnage')
          },
          labels: {
            formatter: (val) => {
              return this.$options.filters.toMRMRTonnage(val)
            }
          },
          min: 0
        },
        {
          seriesName: this.selectedStatement.period.name,
          show: false,
          labels: {
            formatter: (val) => {
              return this.$options.filters.toMRMRTonnage(val)
            }
          }
        },
        {
          seriesName: "Variance",
          opposite: true,
          show: false,
          labels: {
            formatter: () => {
              return null;
            }
          }
        },
        {
          seriesName: "Variance",
          opposite: true,
          show: false,
          labels: {
            formatter: () => {
              return null;
            }
          }
        },
        {
          seriesName: "Variance",
          opposite: true,
          show: false,
          labels: {
            formatter: () => {
              return null;
            }
          }
        },
        {
          seriesName: "Variance",
          opposite: true,
          title: {
            text: 'Variance (%)'
          },
          labels: {
            formatter: (val) => {
              return this.$options.filters.toIntPercentage(val);
            }
          },
          min: -100,
          max: maxTonnageVariance > 100 ? maxTonnageVariance : 100,
          tickAmount: 8
        }
      ];

      const xaxis =  {
        categories
      };

      this.tonnageSeries = [comparedStatementTonnageSerie, selectedStatementTonnageSerie, zeroSerie, plus10Serie, minus10Serie, tonnageVarianceSerie];
      this.$refs.chartTonnage.updateOptions({ xaxis, yaxis : tonnageYaxis});
      if (this.detailedDiagram) {
        this.tableData = tableData;
        this.summaryTableData = [];
      }
      else {
        this.summaryTableData = tableData;
        this.tableData = [];
      }
    },
    getStatementStats(statement, type, miningTypes) {
      const stats =  statement.stats.filter(m => m.resourceType === type && miningTypes.includes(m.miningType));
      let tonnageValue = 0;
      let auOZValue = 0;
      let auGradeValue = 0;
      let auGradeTonnage = 0;
      if (stats !== undefined);
      {
        stats.forEach(stat => {
          const tonnage = this.considerOwnershipPercentage ? stat.tonnage * (statement.ownership / 100) : stat.tonnage;
          tonnageValue += tonnage
          auOZValue += this.considerOwnershipPercentage ? stat.auOz * (statement.ownership / 100) : stat.auOz;
          auGradeTonnage += stat.goldGrade * tonnage;
        });

        auGradeValue = tonnageValue === 0 ? 0 :  auGradeTonnage  / tonnageValue;
      }

      return { 
        tonnageValue, 
        auOZValue, 
        auGradeValue
      }
    },
    getSummaryStatementStats(statement, category, miningTypes) {
      let types = null;
      switch (category) {
      case ResourceCategoryEnum.Reserve:
        types = [ResourceTypeEnum.Proven, ResourceTypeEnum.Probable];
        break;
      case ResourceCategoryEnum.Resource:
        types = [ResourceTypeEnum.Measured, ResourceTypeEnum.Indicated];
        break;
      case ResourceCategoryEnum.Inferred:
        types = [ResourceTypeEnum.Inferred];
        break;
      case ResourceCategoryEnum.PotentialMineral:
        types = [ResourceTypeEnum.PotentialMineral];
        break;
      default:
        types = [];
      }

      let tonnageValue = 0;
      let auOZValue = 0;
      let auGradeValue = 0;
      let auGradeTonnage = 0;

      types.forEach(type => {
        const stats =  statement.stats.filter(m => m.resourceType === type && miningTypes.includes(m.miningType));
        if (stats !== undefined);
        {
          stats.forEach(stat => {
            const tonnage = this.considerOwnershipPercentage ? stat.tonnage * (statement.ownership / 100) : stat.tonnage;
            tonnageValue += tonnage;
            auOZValue += this.considerOwnershipPercentage ? stat.auOz * (statement.ownership / 100) : stat.auOz;
            auGradeTonnage += stat.goldGrade * tonnage;
          });

          auGradeValue = tonnageValue === 0 ? 0 :  auGradeTonnage  / tonnageValue;
        }
      });

      return { 
        tonnageValue, 
        auOZValue, 
        auGradeValue
      }
      
    },
    getSelectedStatement() {
      return this.selectedStatement;
    },    
    getSelectedElementLabel (selected) {
      if  (selected === ElementEnum.Gold) {
        return this.$t('MRMR.Statement.AuOz');
      }
      else if  (selected === ElementEnum.Silver) {
        return this.$t('MRMR.Statement.AgOz');
      }
      else if  (selected === ElementEnum.Copper) {
        return this.$t('MRMR.Statement.CuOz');
      }
      else if  (selected === ElementEnum.Zinc) {
        return this.$t('MRMR.Statement.ZnOz');
      }
      else if  (selected === ElementEnum.Lead) {
        return this.$t('MRMR.Statement.PbOz');
      }
      return "unknown";
    },
    getAvailableElements() {
      const returnUnique = (val, idx, arr) => arr.indexOf(val) === idx;
      const elementsUsed = this.selectedStatement.entries.map(e => e.grades.map(o  => o.element)).flat().filter(returnUnique).sort();
      return this.elements.filter(e => elementsUsed.find(x => x === e.id) !== undefined);
    }
  }
};
</script>
